module.exports = __webpack_public_path__ + "img/icomoon.2bf57bf.svg";